/* eslint-disable react/require-default-props */
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// Components
import MobileCard from '../components/Card/MobileCard';
import DesktopCard from '../components/Card/DesktopCard';

// Actions
import { setSelectedLocation } from '../actions';
import { pushPrimaryCTAInteraction, pushSecondaryCTAInteraction } from '../lib/AnalyticsUtils';
import MarkerUtils from '../lib/MapUtils/MarkerUtils';

// Helpers
import { haveCommonItem } from '../lib/Utils';

class CardContainer extends React.Component {
  /**
   * Handles CTA link click.
   *
   * @param {Boolean} primary - Whether or not the clicked link is the primary link or not.
   */
  static handleLinkClick({ primary }) {
    return primary ? pushPrimaryCTAInteraction() : pushSecondaryCTAInteraction();
  }

  constructor(props) {
    super(props);

    this.state = {
      location: props.selected,
      hidden: !props.selected,
    };

    this.handleClose = this.handleClose.bind(this);
  }

  componentWillReceiveProps(newProps) {
    const { selected, loading } = newProps;
    let newLocation = this.state.location;

    // Check if filters have been updated. If the selected item is no longer a member of the
    // selected filters, then unselect item.
    if (selected && !loading) {
      newLocation = selected;
    }

    // If the filters change, if the selected item is no longer contained within those filters, then
    // nullify the selected item.
    if (
      newProps.filters !== this.props.filters &&
      newLocation &&
      !haveCommonItem(newLocation.types, newProps.filters)
    ) {
      this.props.setSelectedLocation(null);
    }

    this.setState({
      hidden: !selected,
      location: newLocation,
    });
  }

  hasTertiaryLabel() {
    const selectedLocation = this.props.selected;
    const tertiaryLabelStates = ['TX', 'OK'];
    const tertiaryLabelCountries = ['US'];

    if (selectedLocation) {
      const isStoreOrGallery =
        selectedLocation.types.indexOf('store') >= 0 ||
        selectedLocation.types.indexOf('gallery') >= 0;

      if (
        tertiaryLabelCountries.indexOf(this.props.localeCountry) >= 0 &&
        selectedLocation.country === 'United States' &&
        tertiaryLabelStates.indexOf(selectedLocation.province) >= 0 &&
        isStoreOrGallery
      ) {
        return true;
      }
    }

    return false;
  }

  handleClose() {
    this.props.setSelectedLocation(null);
  }

  render() {
    const { content, filters, loading, serviceAvailable, localeCountry } = this.props;
    const { location, hidden } = this.state;

    const type = location ? MarkerUtils.getLocationType(location.types, filters) : null;
    const showTertiaryLabel = this.hasTertiaryLabel();
    const showFooter = localeCountry !== 'IL';

    return (
      <div className="card_container">
        <MobileCard
          hidden={hidden}
          primaryLink="/drive"
          secondaryLink="/findus/list"
          showTertiaryLabel={showTertiaryLabel}
          location={location}
          content={content}
          loading={loading}
          handleClose={this.handleClose}
          handleLinkClick={CardContainer.handleLinkClick}
          type={type}
          showFooter={showFooter}
        />
        <DesktopCard
          hidden={hidden}
          location={location}
          primaryLink="/drive"
          secondaryLink="/findus/list"
          showTertiaryLabel={showTertiaryLabel}
          content={content}
          loading={loading}
          lowered={serviceAvailable}
          handleClose={this.handleClose}
          handleLinkClick={CardContainer.handleLinkClick}
          type={type}
          showFooter={showFooter}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    selected: state.locations.selected,
    loading: state.locations.selectedLoading,
    content: state.content.locationDetails,
    filters: state.locations.filters,
    serviceAvailable: state.service.available,
    localeCountry: state.app.country,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setSelectedLocation: location => dispatch(setSelectedLocation(location)),
  };
};

CardContainer.propTypes = {
  selected: PropTypes.shape({ type: PropTypes.array, id: PropTypes.string }),
  loading: PropTypes.bool,
  filters: PropTypes.arrayOf(PropTypes.string),
  content: PropTypes.objectOf(PropTypes.object),
  setSelectedLocation: PropTypes.func,
  serviceAvailable: PropTypes.bool,
  localeCountry: PropTypes.string,
};

CardContainer.defaultProps = {
  selected: null,
  content: {},
};

export default connect(mapStateToProps, mapDispatchToProps)(CardContainer);
